import gsap from 'gsap';

export const initObservers = () => {
  const items = document.querySelectorAll('.reveal');

  items.forEach((el) => {
    const threshold = parseFloat(el.dataset.threshold || 0.25);
    const once = el.dataset.once !== 'false';

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add('in-view');
          gsap.fromTo(el, { opacity: 0, y: 30 }, { opacity: 1, y: 0, duration: 0.6 });
          if (once) observer.unobserve(el);
        } else {
          if (!once) el.classList.remove('in-view');
        }
      },
      { threshold }
    );

    observer.observe(el);
  });
};
